import { NgModule } from '@angular/core';
import { OccConfig, PRODUCT_NORMALIZER, provideConfig, RoutingConfig } from '@spartacus/core';
import { ProductPrettyNameNormalizer } from './product-pretyy-name.normalizer';

@NgModule({
  imports: [
    /*  ConfigModule.withConfig({
      // configure product routes
      routing: {
        routes: {
          product: {
            paths: ['product/:productCode/:prettyName', 'product/:productCode'],
            // paths: ['product/:productCode/:name', 'product/:productCode'],
          },
          explodedView: {
            paths: [
              'exploded-view/:explodedViewId',
              'product/:productCode/:name/exploded-view/:explodedViewId',
              'product/:productCode/exploded-view/:explodedViewId',
            ],
          },
        },
      },
    } as RoutingConfig),*/
  ],
  providers: [
    provideConfig(<RoutingConfig>{
      // custom routing configuration for e2e testing
      routing: {
        routes: {
          product: {
            paths: ['product/:productCode/:prettyName', 'product/:productCode'],
            // paths: ['product/:productCode/:name', 'product/:productCode'],
          },
          explodedView: {
            paths: [
              'exploded-view/:explodedViewId',
              'product/:productCode/:name/exploded-view/:explodedViewId',
              'product/:productCode/exploded-view/:explodedViewId',
            ],
          },
        },
      },
      paramsMapping: {
        productCode: 'code',
      },
    }),
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          endpoints: {
            cart: 'users/${userId}/carts/${cartId}?fields=FULL',
            carts: 'users/${userId}/carts?fields=FULL',
            product: {
              details:
                // tslint:disable-next-line: max-line-length
                'products/${productCode}?fields=FULL',
              list:
                // tslint:disable-next-line: max-line-length
                'products/${productCode}?fields=name,purchasable,baseOptions(DEFAULT),baseProduct,variantMatrix,variantOptions(DEFAULT),variantType',
            },
            productSearch:
              // tslint:disable-next-line: max-line-length
              'products/search?fields=FULL&query=${query}',
          },
        },
      },
    }),
    {
      provide: PRODUCT_NORMALIZER,
      useClass: ProductPrettyNameNormalizer,
      multi: true,
    },
  ],
})
export class ProductRoutesModule {}
